import { useCallback } from 'react';

import { di } from 'react-magnetic-di';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

const SOLUTION_CREATE_FLOW_ACTION_SUBJECT = 'solutionCreateFlow';
const ANALYTICS_OBJECT_TYPE = 'skill';

export type SkillCreateFlowTouchPoint =
	| 'manualCreationLinks'
	| 'studioUniversalCreate'
	| 'studioCustomSkillsPage'
	| 'chatImportSkillButton'
	| 'chatSkillListBuildSkill'
	| 'chatAutoSuggestBuildSkill'
	| 'chatTypeAheadBuildSkill'
	| 'chatCreateSkillWithChat'
	| 'chatCreateSkillWithEditor';

export const useCustomSkillsAnalytics = (): {
	fireSkillCreateFlowViewed: (touchPoint: SkillCreateFlowTouchPoint) => void;
	fireSkillCreateFlowStart: (touchPoint: SkillCreateFlowTouchPoint) => void;
} => {
	di(useAnalyticsEvents);

	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireSkillCreateFlowEvent = useCallback(
		(action: 'viewed' | 'started', touchPoint: SkillCreateFlowTouchPoint) => {
			createAnalyticsEvent({
				action,
				actionSubject: SOLUTION_CREATE_FLOW_ACTION_SUBJECT,
				attributes: {
					objectType: ANALYTICS_OBJECT_TYPE,
					touchPoint,
				},
			}).fire('atlaskit');
		},
		[createAnalyticsEvent],
	);

	const fireSkillCreateFlowViewed = useCallback(
		(touchPoint: SkillCreateFlowTouchPoint) => {
			fireSkillCreateFlowEvent('viewed', touchPoint);
		},
		[fireSkillCreateFlowEvent],
	);

	const fireSkillCreateFlowStart = useCallback(
		(touchPoint: SkillCreateFlowTouchPoint) => {
			fireSkillCreateFlowEvent('started', touchPoint);
		},
		[fireSkillCreateFlowEvent],
	);

	return { fireSkillCreateFlowViewed, fireSkillCreateFlowStart };
};
